import { render, staticRenderFns } from "./aed-ownerChange.vue?vue&type=template&id=22cb4224&"
import script from "./aed-ownerChange.vue?vue&type=script&lang=js&"
export * from "./aed-ownerChange.vue?vue&type=script&lang=js&"
import style0 from "./aed-ownerChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports